import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loaderSource = new Subject<boolean>();
  private loaderCount = 0;
  private showTimer?: ReturnType<typeof setTimeout>;
  private hideTimer?: ReturnType<typeof setTimeout>;
  private loaderStartTime: number | null = null;

  loaderObserver = this.loaderSource.asObservable();

  show(): void {
    this.loaderCount++;
    this.showTimer = setTimeout(() => {
      if (this.loaderCount > 0) {
        this.loaderSource.next(true);
        this.loaderStartTime = Date.now();
      }
      this.showTimer = undefined;
    }, 300);
  }

  hide(): void {
    if (this.loaderCount > 0) {
      this.loaderCount--;
    }

    if (this.loaderCount <= 0) {
      // if not loading anymore
      var extraDelay: number = 0;
      if(this.loaderStartTime){
        var loaderShowTime: number = Date.now() - this.loaderStartTime;
        extraDelay = loaderShowTime > 800 ? 0 : 800 - loaderShowTime;
        this.loaderStartTime = null;
      }
      this.hideTimer = setTimeout(() => this._hide(), extraDelay);
    }
  }

  private _hide():void {
    this.showTimer = undefined;
    this.loaderSource.next(false);
    this.hideTimer = undefined;
  }
}
